
  <main class="main-content">
    <div class="page-content">

      <!-- Page Header -->
      <div class="page-header">
        <div class="page-header-left">
          <div class="page-title-row">
            <span class="page-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            </span>
            <h1>Circled Intelligence</h1>
          </div>
          <p class="page-desc">Generate property-level pricing, negotiation, rental and investment intelligence.</p>
        </div>
        <div class="page-header-actions">
          <button type="button" class="btn-outline" (click)="openBulkUpload()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            <span>Bulk Upload</span>
          </button>
          <button class="btn-create" (click)="openNewAnalysis()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span>Create New Intelligence</span>
          </button>
        </div>
      </div>

      <!-- Stats Row -->
      <div class="stats-row">
        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-icon stat-icon-blue">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            </span>
            <span class="stat-label">Properties Analyzed</span>
          </div>
          <div class="stat-value">{{ stats?.propertiesAnalyzed }}</div>
          <div class="stat-meta">Generated CI in this list</div>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-icon stat-icon-amber">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            </span>
            <span class="stat-label">Pending Analysis</span>
          </div>
          <div class="stat-value">{{ stats?.pendingAnalysis }}</div>
          <div class="stat-meta">Draft properties in this list</div>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <span class="stat-icon stat-icon-green">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </span>
            <span class="stat-label">Last Analysis</span>
          </div>
          <div class="stat-value stat-value-date">{{ stats?.lastAnalysisDate }}</div>
          <div class="stat-meta">{{ stats?.lastAnalysisProperty }}</div>
        </div>
      </div>

      <!-- Recent Intelligence Table -->
      <section class="table-section">
        <div class="table-header">
          <h2>Recent Intelligence</h2>
        </div>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Property</th>
                <th>Micro Market</th>
                <th>Quoted Price</th>
                <th>Benchmark PSF</th>
                <th>Circled Verdict</th>
                <th>Last Updated</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of recentIntel">
                <td class="td-property">{{ row.property }}</td>
                <td>{{ row.microMarket }}</td>
                <td class="td-mono">{{ row.quotedPrice }}</td>
                <td class="td-mono">{{ row.benchmarkPSF }}</td>
                <td>
                  <span class="verdict-badge" [ngClass]="getVerdictClass(row.verdict)">
                    {{ row.verdict }}
                  </span>
                </td>
                <td class="td-date">{{ row.lastUpdated }}</td>
                <td>
                  <span class="status-badge" [ngClass]="getStatusClass(row.status)">
                    {{ row.status }}
                  </span>
                </td>
                <td>
                  <div class="intel-actions">
                    <button type="button" class="btn-view" (click)="openView(row)">View</button>
                    <button
                      *ngIf="row.status === 'Completed' && row.id"
                      type="button"
                      class="btn-view"
                      [attr.aria-label]="'Edit CI for ' + row.property"
                      (click)="openNewAnalysis(row.id)"
                    >Edit</button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!intelLoading && !recentIntel?.length">
                <td colspan="8" class="td-empty">No intelligence yet.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <nav class="table-pagination" *ngIf="pagination && pagination.totalPages > 1" aria-label="Recent Intelligence pages">
          <span class="page-range">{{ pageRangeLabel }}</span>
          <div class="page-buttons">
            <button type="button" class="page-btn" [disabled]="page <= 1 || intelLoading" (click)="goToPage(page - 1)" aria-label="Previous page">‹</button>
            <ng-container *ngFor="let p of pageNumbers">
              <span *ngIf="p === null" class="page-gap">…</span>
              <button
                *ngIf="p !== null"
                type="button"
                class="page-btn"
                [class.active]="p === page"
                [attr.aria-current]="p === page ? 'page' : null"
                [disabled]="intelLoading"
                (click)="goToPage(p)"
              >{{ p }}</button>
            </ng-container>
            <button type="button" class="page-btn" [disabled]="page >= pagination.totalPages || intelLoading" (click)="goToPage(page + 1)" aria-label="Next page">›</button>
          </div>
        </nav>
      </section>

      <!-- View Intelligence Modal -->
      <div class="modal-overlay" *ngIf="viewRow" (click)="closeView()">
        <div class="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="ci-view-title" (click)="$event.stopPropagation()">
          <div class="panel-header">
            <div>
              <h2 id="ci-view-title">{{ viewRow.property }}</h2>
              <p class="modal-subtitle">{{ viewRow.microMarket || '—' }} · Updated {{ viewRow.lastUpdated }}</p>
            </div>
            <button type="button" class="panel-close" aria-label="Close" (click)="closeView()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="modal-body">
            <div class="modal-badges">
              <span class="verdict-badge" [ngClass]="getVerdictClass(viewRow.verdict)">{{ viewRow.verdict }}</span>
              <span class="status-badge" [ngClass]="getStatusClass(viewRow.status)">{{ viewRow.status }}</span>
            </div>

            <div class="modal-user">
              <img *ngIf="viewUser?.advisorImg; else avatarInitial" class="modal-user-avatar" [src]="viewUser?.advisorImg" alt="" />
              <ng-template #avatarInitial>
                <span class="modal-user-avatar" aria-hidden="true">{{ (viewUser?.name || '?').charAt(0).toUpperCase() }}</span>
              </ng-template>
              <div class="modal-user-info">
                <span class="detail-label">Created by</span>
                <ng-container *ngIf="viewUser as a; else userFallback">
                  <span class="modal-user-name">
                    {{ a.name || '—' }}
                    <span class="modal-user-role" *ngIf="advisorRole(a)">{{ advisorRole(a) }}</span>
                  </span>
                  <span class="modal-user-meta" *ngIf="a.email || a.phone || a.alternativePhone">
                    {{ joinDefined(a.email, a.phone, a.alternativePhone) }}
                  </span>
                  <span class="modal-user-meta" *ngIf="a.specialization || a.experience">
                    {{ joinDefined(a.specialization, a.experience ? a.experience + ' yrs experience' : '') }}
                  </span>
                  <span class="modal-user-meta" *ngIf="a.location">{{ a.location }}</span>
                </ng-container>
                <ng-template #userFallback>
                  <span class="modal-user-meta">{{ viewUserLoading ? 'Loading advisor…' : viewLoading ? 'Loading…' : (viewUserError || 'Advisor details unavailable') }}</span>
                </ng-template>
              </div>
              <span class="modal-user-date">Updated {{ viewRecord?.updatedAt ? (viewRecord?.updatedAt | date: 'medium') : viewRow.lastUpdated }}</span>
            </div>

            <div class="detail-grid">
              <div class="detail-item"><span class="detail-label">Quoted Price</span><span class="detail-value td-mono">{{ viewRow.quotedPrice }}</span></div>
              <div class="detail-item"><span class="detail-label">Benchmark PSF</span><span class="detail-value td-mono">{{ viewRow.benchmarkPSF }}</span></div>
            </div>

            <div class="modal-state" *ngIf="viewLoading">Loading details…</div>
            <div class="modal-state modal-error" *ngIf="viewError">{{ viewError }}</div>

            <ng-container *ngIf="viewRecord as r">
              <h3 class="modal-section-title">Pricing</h3>
              <div class="detail-grid">
                <div class="detail-item"><span class="detail-label">Size</span><span class="detail-value">{{ r.size ? (r.size | number) + ' sq ft' : '—' }}</span></div>
                <div class="detail-item"><span class="detail-label">Quoted Unit Price</span><span class="detail-value td-mono">{{ formatCurrency(r.quotedUnitPrice) }}</span></div>
                <div class="detail-item"><span class="detail-label">Quoted PSF</span><span class="detail-value td-mono">{{ formatCurrency(r.quotedPsf) }}</span></div>
                <div class="detail-item"><span class="detail-label">Benchmark PSF</span><span class="detail-value td-mono">{{ formatCurrency(r.benchmarkPsf) }}</span></div>
                <div class="detail-item"><span class="detail-label">Ask vs Benchmark</span><span class="detail-value">{{ r.askVsBenchmarkPercent != null ? (r.askVsBenchmarkPercent | number: '1.0-2') + '%' : '—' }}</span></div>
                <div class="detail-item"><span class="detail-label">Benchmark Logic</span><span class="detail-value">{{ r.benchmarkLogicUsed || '—' }}</span></div>
              </div>

              <h3 class="modal-section-title">Negotiation</h3>
              <div class="detail-grid">
                <div class="detail-item"><span class="detail-label">Suggested Offer</span><span class="detail-value td-mono">{{ r.websiteSuggestedOffer || formatCurrency(r.suggestedOfferValue ?? null) }}</span></div>
                <div class="detail-item"><span class="detail-label">Likely Close Band</span><span class="detail-value td-mono">{{ r.websiteLikelyCloseBand || '—' }}</span></div>
                <div class="detail-item"><span class="detail-label">Fair Value Band</span><span class="detail-value td-mono">{{ formatCurrency(r.fairValueBandLow ?? null) }} – {{ formatCurrency(r.fairValueBandHigh ?? null) }}</span></div>
                <div class="detail-item"><span class="detail-label">Trophy Override</span><span class="detail-value">{{ r.trophyOverride ? 'Yes' : 'No' }}</span></div>
              </div>

              <ng-container *ngIf="r.averageRentPerMonth || r.rentalYield">
                <h3 class="modal-section-title">Rental</h3>
                <div class="detail-grid">
                  <div class="detail-item"><span class="detail-label">Avg Rent / Month</span><span class="detail-value td-mono">{{ formatCurrency(r.averageRentPerMonth ?? null) }}</span></div>
                  <div class="detail-item"><span class="detail-label">Rental Yield</span><span class="detail-value">{{ r.rentalYield != null ? (r.rentalYield | number: '1.0-2') + '%' : '—' }}</span></div>
                </div>
              </ng-container>

              <ng-container *ngIf="r.landAssessment as la">
                <h3 class="modal-section-title">Land &amp; Building</h3>
                <div class="detail-grid">
                  <div class="detail-item"><span class="detail-label">Final Land Value</span><span class="detail-value td-mono">{{ formatCurrency(la.finalLandValue) }}</span></div>
                  <div class="detail-item"><span class="detail-label">Building Value</span><span class="detail-value td-mono">{{ formatCurrency(la.totalBuildingValue) }}</span></div>
                  <div class="detail-item"><span class="detail-label">Assessed Value</span><span class="detail-value td-mono">{{ formatCurrency(la.assessedValue) }}</span></div>
                  <div class="detail-item"><span class="detail-label">Ask vs CI</span><span class="detail-value">{{ la.askVsCiPercent | number: '1.0-2' }}%</span></div>
                </div>
              </ng-container>

              <ng-container *ngIf="r.lastFiveTransactions?.length">
                <h3 class="modal-section-title">Recent Transactions</h3>
                <table class="modal-table">
                  <thead><tr><th>Price</th><th>Source</th><th>Date</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let t of r.lastFiveTransactions">
                      <td class="td-mono">{{ formatCurrency(t.price) }}</td>
                      <td>{{ t.source || '—' }}</td>
                      <td>{{ t.date ? (t.date | date: 'mediumDate') : '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="r.verdictDescription || r.analystNotes">
                <h3 class="modal-section-title">Notes</h3>
                <p class="modal-text" *ngIf="r.verdictDescription">{{ r.verdictDescription }}</p>
                <p class="modal-text" *ngIf="r.analystNotes">{{ r.analystNotes }}</p>
              </ng-container>

            </ng-container>

          </div>

          <div class="panel-actions">
            <button type="button" class="btn-secondary" (click)="closeView()">Close</button>
            <button type="button" class="btn-primary" *ngIf="viewRow.id" (click)="editFromView()">Edit</button>
          </div>
        </div>
      </div>

      <!-- Bulk Upload Modal -->
      <div class="modal-overlay" *ngIf="bulkOpen" (click)="closeBulkUpload()">
        <div class="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="ci-bulk-title" (click)="$event.stopPropagation()">
          <div class="panel-header">
            <div>
              <h2 id="ci-bulk-title">Bulk Upload Intelligence</h2>
              <p class="modal-subtitle">Upload an Excel sheet to calculate CI for many properties at once.</p>
            </div>
            <button type="button" class="panel-close" aria-label="Close" [disabled]="bulkUploading" (click)="closeBulkUpload()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="modal-body">
            <div class="bulk-step">
              <span class="bulk-step-num">1</span>
              <div class="bulk-step-body">
                <span class="bulk-step-title">Download the template</span>
                <span class="bulk-step-text">
                  Fill one row per property in the "CI Bulk Upload" sheet. Supports Primary Project, Resale Project, Plot / Land and Independent House.
                  The Instructions sheet lists required columns and allowed values.
                </span>
                <button type="button" class="btn-link" [disabled]="bulkTemplateLoading" (click)="downloadBulkTemplate()">
                  {{ bulkTemplateLoading ? 'Downloading…' : 'Download template (.xlsx)' }}
                </button>
              </div>
            </div>

            <div class="bulk-step">
              <span class="bulk-step-num">2</span>
              <div class="bulk-step-body">
                <span class="bulk-step-title">Choose the filled file</span>
                <label class="bulk-dropzone" [class.has-file]="bulkFile">
                  <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                         [disabled]="bulkUploading" (change)="onBulkFileSelected($event)" />
                  <span>{{ bulkFile ? bulkFile.name : 'Click to select an .xlsx file' }}</span>
                </label>
              </div>
            </div>

            <div class="bulk-step">
              <span class="bulk-step-num">3</span>
              <div class="bulk-step-body">
                <span class="bulk-step-title">Save as</span>
                <div class="bulk-radio-row">
                  <label class="bulk-radio">
                    <input type="radio" name="bulkStatus" value="GENERATED" [checked]="bulkStatus === 'GENERATED'"
                           [disabled]="bulkUploading" (change)="bulkStatus = 'GENERATED'" />
                    Generated CI
                  </label>
                  <label class="bulk-radio">
                    <input type="radio" name="bulkStatus" value="DRAFT" [checked]="bulkStatus === 'DRAFT'"
                           [disabled]="bulkUploading" (change)="bulkStatus = 'DRAFT'" />
                    Draft
                  </label>
                </div>
              </div>
            </div>

            <div class="modal-state" *ngIf="bulkUploading">Calculating CI for each row… this can take a minute for large files.</div>
            <div class="modal-state modal-error" *ngIf="bulkError">{{ bulkError }}</div>

            <ng-container *ngIf="bulkResult as br">
              <div class="bulk-summary">
                <div class="bulk-summary-item"><span class="detail-label">Rows</span><span class="bulk-summary-value">{{ br.totalRows }}</span></div>
                <div class="bulk-summary-item bulk-ok"><span class="detail-label">Succeeded</span><span class="bulk-summary-value">{{ br.succeeded }}</span></div>
                <div class="bulk-summary-item" [class.bulk-fail]="br.failed > 0"><span class="detail-label">Failed</span><span class="bulk-summary-value">{{ br.failed }}</span></div>
              </div>

              <ng-container *ngIf="br.errors.length">
                <h3 class="modal-section-title">Failed rows</h3>
                <table class="modal-table">
                  <thead><tr><th>Row</th><th>Property</th><th>Reason</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let e of br.errors">
                      <td class="td-mono">{{ e.row }}</td>
                      <td>
                        {{ e.propertyName || '—' }}
                        <span class="bulk-sub" *ngIf="e.listingUnitName || e.propertyCategory">{{ joinDefined(e.listingUnitName || undefined, e.propertyCategory || undefined) }}</span>
                      </td>
                      <td><div class="bulk-reason" *ngFor="let msg of e.errors">{{ msg }}</div></td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="br.results.length">
                <h3 class="modal-section-title">Created</h3>
                <table class="modal-table">
                  <thead><tr><th>Row</th><th>Property</th><th>Benchmark PSF</th><th>Verdict</th><th>Status</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let r of br.results">
                      <td class="td-mono">{{ r.row }}</td>
                      <td>
                        {{ r.propertyName || '—' }}
                        <span class="bulk-sub" *ngIf="r.listingUnitName">{{ r.listingUnitName }}</span>
                      </td>
                      <td class="td-mono">{{ formatCurrency(r.benchmarkPsf) }}</td>
                      <td>{{ r.adjustedVerdict }}</td>
                      <td>
                        <span class="status-badge" [ngClass]="getStatusClass(r.status === 'GENERATED' ? 'Completed' : 'Draft')">
                          {{ r.status === 'GENERATED' ? 'Completed' : 'Draft' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </ng-container>
          </div>

          <div class="panel-actions">
            <button type="button" class="btn-secondary" [disabled]="bulkUploading" (click)="closeBulkUpload()">
              {{ bulkResult ? 'Done' : 'Cancel' }}
            </button>
            <button type="button" class="btn-primary valid" [disabled]="!bulkFile || bulkUploading" (click)="submitBulkUpload()">
              {{ bulkUploading ? 'Uploading…' : bulkResult ? 'Upload Again' : 'Upload & Calculate' }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </main>
